


















import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

@Component({
  components: {
    FontAwesomeIcon,
  },
  name: 'respondeco-icon',
})
export default class RespondecoIcon extends Vue {
  @Prop(Boolean)
  public readonly border!: boolean

  @Prop(Boolean)
  public readonly fixedWidth!: boolean

  @Prop({
    type: String,
    validator(value) {
      return ['horizontal', 'vertical', 'both'].indexOf(value) > -1
    },
  })
  public readonly flip!: string

  @Prop({
    required: true,
    type: String,
  })
  public readonly icon!: string

  @Prop(String)
  public readonly mask!: string

  @Prop(Boolean)
  public readonly listItem!: boolean

  @Prop({
    type: String,
    validator(value) {
      return ['right', 'left'].indexOf(value) > -1
    },
  })
  public readonly pull!: string

  @Prop(Boolean)
  public readonly pulse!: boolean

  @Prop({
    type: Number,
    validator(value) {
      return [0, 90, 180, 270].indexOf(value) > -1
    },
  })
  public readonly rotation!: number

  @Prop({
    type: String,
    validator(value) {
      return (
        ['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'].indexOf(
          value
        ) > -1
      )
    },
  })
  public readonly size!: string

  @Prop(Boolean)
  public readonly spin!: boolean

  @Prop({
    type: [Object, String],
  })
  public readonly transform!: object | string

  @Prop({
    type: [Boolean, String],
  })
  public readonly symbol!: string | boolean

  get normalisedIcon() {
    let normalised: string | string[] = this.icon

    if (this.icon.indexOf(' ') > -1) {
      // "{type} {icon}"
      normalised = this.icon.split(' ')
    } else {
      normalised = ['fas', normalised]
    }

    return normalised
  }
}
